import { TestType, TestTypeStatsResponsePrivate } from '@tests/types';

export const getTestTypeCount = (
  testsCount: TestTypeStatsResponsePrivate[],
  testType: TestType | 'all',
) => testsCount?.find(({ type }) => type === testType)?.count || 0;
